export interface FirstSendNotice {
  enabled: boolean;
  isFirstSend: boolean;
  thresholdAmount: number;
  currency: string;
  title: string;
  body: string;
}

const DEBIT_FUNDING = new Set([
  "DEBIT_CARD",
  "CREDIT_CARD",
  "ACH",
  "RTP",
  "BANK_BALANCE",
]);

export function fundingDebitsAccountOrCard(
  method: string | null | undefined
): boolean {
  if (!method) return false;
  return DEBIT_FUNDING.has(method.toUpperCase());
}

export function shouldShowFirstSendWarning(input: {
  notice: FirstSendNotice | null;
  sendAmount: number | null;
  sourceCurrency?: string | null;
  fundingMethod?: string | null;
}): boolean {
  const { notice, sendAmount, sourceCurrency, fundingMethod } = input;
  if (!notice?.enabled || !notice.isFirstSend) return false;
  if (!notice.title || !notice.body) return false;
  if (sendAmount == null || !(sendAmount > notice.thresholdAmount)) return false;
  if (!sourceCurrency) return false;
  if (sourceCurrency.toUpperCase() !== notice.currency.toUpperCase()) return false;
  return fundingDebitsAccountOrCard(fundingMethod);
}
